import { render, staticRenderFns } from "./StatefulSet.vue?vue&type=template&id=dbf2018e&"
import script from "./StatefulSet.vue?vue&type=script&lang=js&"
export * from "./StatefulSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports